import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation, Outlet } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = useState(window.innerWidth >= 1200);
  const [currentRoute, setCurrentRoute] = useState("Main Dashboard");

  // Define routes where "Courses" should be displayed
  const courseRoutes = [
     "/admin/edit-courses",
     "/admin/modules-courses",
     "/admin/program-courses",
     "/admin/support-courses",
     "/admin/section1-courses",
     "/admin/section2-courses",
    ];

  useEffect(() => {
    // ✅ Add & Remove event listener for resize
    const handleResize = () => setOpen(window.innerWidth >= 1200);
    window.addEventListener("resize", handleResize);
    
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setCurrentRoute(getActiveRoute(routes));
  }, [location.pathname]); // ✅ Updates on route change

  const getActiveRoute = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      const routePath = `${routes[i].layout}/${routes[i].path}`;

      // ✅ Check if location pathname starts with a dynamic course route
      if (courseRoutes.some((route) => location.pathname.startsWith(route))) {
        return "Courses";
      }

      if (location.pathname.includes(routePath)) {
        return routes[i].name;
      }
    }
    return "Main Dashboard"; // Default value
  };

  const getActiveNavbar = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.includes(`${routes[i].layout}${routes[i].path}`)) {
        return routes[i].secondary;
      }
    }
    return false;
  };

  const getRoutes = (routes) => {
    return routes.map((route, key) => {
      if (route.layout === "/admin") {
        return (
          <React.Fragment key={key}>
            {/* Main Route */}
            <Route path={route.path} element={route.component} />
            
            {/* Sub Routes - Nested Routes */}
            {route.subRoutes && (
              <Route path={route.path} element={<Outlet />}>
                {route.subRoutes.map((subRoute, subKey) => (
                  <Route path={subRoute.path} element={subRoute.component} key={subKey} />
                ))}
              </Route>
            )}
          </React.Fragment>
        );
      }
      return null;
    });
  };

  document.documentElement.dir = "ltr";

  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        <main className="mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]">
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"Horizon UI Tailwind React"}
              brandText={currentRoute}
              secondary={getActiveNavbar(routes)}
              {...rest}
            />
            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {getRoutes(routes)}
                <Route path="/" element={<Navigate to="/admin/default" replace />} />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
